<template>
<div class="accordion accordion-flush" id="accordionFlushExample">
    <div class="col-12">
        <div class="section-title">
            <h2 class="mt-3 mb-5 title text-center">
                Frequently Asked <span style="color: #f6ec32;"> Questions.</span>
            </h2>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="flush-headingOne">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                What is the duration of the virtual internship?
            </button>
        </h2>
        <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
            <div class="accordion-body">The virtual internship at CODEX EARTH has a duration of 3 months. This timeframe is designed to provide interns with a comprehensive learning experience, allowing them to gain practical skills and insights into their chosen field. If you have further questions about the internship program's duration, please contact us.</div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="flush-headingTwo">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                What are the selection criteria?
            </button>
        </h2>
        <div id="flush-collapseTwo" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
            <div class="accordion-body">We welcome students who are passionate about the IT field and committed to their internship. While technical qualifications can be beneficial for some roles, we prioritize enthusiasm and a genuine desire to learn and contribute. Apply if you're eager to join us in your IT journey. For role-specific requirements or more details, check our application guidelines or contact us.</div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="flush-headingThree">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                When does the internship start and end?
            </button>
        </h2>
        <div id="flush-collapseThree" class="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
            <div class="accordion-body">The internship is scheduled to start on Nov 1st and will run until Dec 1st, spanning a duration of one month. This timeframe provides interns with a comprehensive and rewarding experience. We look forward to having you join us during this period. If you have any further questions or need additional information, please contact us.</div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="flush-headingFour">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                Is there any fee for the internship?
            </button>
        </h2>
        <div id="flush-collapseFour" class="accordion-collapse collapse" aria-labelledby="flush-headingFour" data-bs-parent="#accordionFlushExample">
            <div class="accordion-body">
                Yes, there is a registration fee of Rs. 100 to enroll in the internship program. However, once registered, all the materials and resources provided during the internship will be available to you free of charge. This fee helps cover administrative costs and ensures you have access to valuable learning opportunities. If you have any questions regarding the registration process or fees, please contact us for further assistance.
            </div>
        </div>
    </div>

    <!-- New accordion item 2 -->
    <div class="accordion-item">
        <h2 class="accordion-header" id="flush-headingFive">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                Is the internship online or offline?
            </button>
        </h2>
        <div id="flush-collapseFive" class="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
            <div class="accordion-body">
                The internship is entirely online and virtual, spanning a total of 3 months. You can participate from anywhere with an internet connection, making it accessible and convenient for students across various locations. If you have any specific questions about the virtual internship format, please feel free to contact us for more details.
            </div>
        </div>
    </div>

    <!-- New accordion item 3 -->
    <div class="accordion-item">
        <h2 class="accordion-header" id="flush-headingSix">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix">
                When will I receive the offer letter?
            </button>
        </h2>
        <div id="flush-collapseSix" class="accordion-collapse collapse" aria-labelledby="flush-headingSix" data-bs-parent="#accordionFlushExample">
            <div class="accordion-body">
                You can expect to receive the offer letter by the end of this month. We're excited to have you on board for the internship and will ensure that you receive all the necessary details and documentation in a timely manner. If you have any further inquiries or need additional information, please don't hesitate to contact us.
            </div>
        </div>
    </div>

</div>
</template>


